import axios from "axios";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;
// Get available configuration sections for a client

export const getAllQuotedItems = async (clientId) => {
  try {
    const response = await axios.get(`${API_URL}/workflows/p2p/${clientId}/all-quoted-items`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all quoted items:", error);
    throw error;
  }
};

export const getSubitemsByItemId = async (itemId, clientId) => {
  try {
    const response = await axios.get(`${API_URL}/workflows/p2p/${clientId}/items/${itemId}/subitems`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subitems by item ID:", error);
    throw error;
  }
}
